export const CMS_LABEL = 'CMS 116';
